// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__3Ym24","approved":"Status_approved__1-JUr","rejected":"Status_rejected__1r-w9","expired":"Status_expired__1AkDx","label":"Status_label__bmdOi"};